import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

import { IApprovalRequest, IApprovalRequestCategory, ICategoryDetail } from '@appshared';

@Injectable({
  providedIn: 'root',
})
export class CategoryApiService {
  protected resourceUrl = '/hrm-portal-api/api/categories/';

  constructor(
    public http: HttpClient
  ) {}

  getRequestTypes(): Observable<any> {
    return this.http.get<IApprovalRequest>(`${this.resourceUrl}request-types/`);
  }

  getCategories(): Observable<IApprovalRequestCategory[]> {
    return this.http.get<IApprovalRequestCategory[]>(`${this.resourceUrl}`);
  }

  getCategoryById(id: string): Observable<ICategoryDetail> {
    return this.http.get<ICategoryDetail>(`${this.resourceUrl}` + id);
  }

  updateCategory(id: string, categoryDetail: ICategoryDetail): Observable<any> {
    return this.http.put<ICategoryDetail>(`${this.resourceUrl}` + id, categoryDetail);
  }

}
